function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import FreeTextPoll from './free_text_poll';
import DiscourseResults from './discourse_results';
import DiscourseVotes from './discourse_votes';
var QA_FETCH_INTERVAL = 3000;

var Discourse = /*#__PURE__*/function (_FreeTextPoll) {
  _inheritsLoose(Discourse, _FreeTextPoll);

  function Discourse() {
    return _FreeTextPoll.apply(this, arguments) || this;
  }

  var _proto = Discourse.prototype;

  _proto.showPath = function showPath() {
    var permalink = this.get('permalink');
    return "/discourses/" + permalink;
  };

  _proto.fetch = function fetch(options) {
    this.fetchOptions = options;
    return _FreeTextPoll.prototype.fetch.apply(this, arguments);
  };

  _proto.sendToListUrl = function sendToListUrl() {
    return undefined;
  }
  /**
   * Live update the discourse data
   * Not using instance.start as this doesn't use firehose
   */
  ;

  _proto.liveUpdate = function liveUpdate() {
    // Fetch every 3 seconds
    this.fetchInterval = setInterval(this.fetch.bind(this), QA_FETCH_INTERVAL);
  };

  _proto.stopLiveUpdate = function stopLiveUpdate() {
    clearInterval(this.fetchInterval);
  };

  _createClass(Discourse, [{
    key: "defaultType",
    get: function get() {
      return 'discourse';
    }
    /**
     * Collection of participant submitted question results. This overrides the
     * base property to make it return a discourse results collection instead.
     * @return {Results}
     */

  }, {
    key: "results",
    get: function get() {
      if (!this._results) {
        this._results = new DiscourseResults(this.get('results'), {
          poll: this
        });
      }

      return this._results;
    }
  }, {
    key: "myVotes",
    get: function get() {
      if (!this._myVotes) {
        this._myVotes = new DiscourseVotes(this.get('my_votes'), {
          poll: this
        });
      }

      return this._myVotes;
    }
  }]);

  return Discourse;
}(FreeTextPoll);

export { Discourse as default };